"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _useTracker = _interopRequireDefault(require("./useTracker"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tracker = function Tracker() {
  (0, _useTracker.default)();
  return null;
};

var _default = Tracker;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9ob29rcy9pbnRlcm5hbC9UcmFja2VyLnRzIl0sIm5hbWVzIjpbIlRyYWNrZXIiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7OztBQUVBLElBQU1BLE9BQXFCLEdBQUcsU0FBeEJBLE9BQXdCLEdBQU07QUFDbEM7QUFFQSxTQUFPLElBQVA7QUFDRCxDQUpEOztlQU1lQSxPIiwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdXNlVHJhY2tlciBmcm9tICcuL3VzZVRyYWNrZXInO1xuXG5jb25zdCBUcmFja2VyOiBSZWFjdC5GQzx7fT4gPSAoKSA9PiB7XG4gIHVzZVRyYWNrZXIoKTtcblxuICByZXR1cm4gbnVsbDtcbn07XG5cbmV4cG9ydCBkZWZhdWx0IFRyYWNrZXI7XG4iXX0=